import is from 'is_js';
import { Record, Map, List } from 'immutable';

// TODO: For Let's Talk default content hack for OMO-2403
const LETS_TALK_TYPE_NAME = 'Let\'s Talk';
const LETS_TALK_DEFAULT_CONTENT =
    'The student has been assigned to complete a short 30-90 second presentation on a topic given by the teacher.';

const HomeworkTypeRecord = Record({
  id: undefined,
  name: undefined,
  courseTypeLevelId: undefined,
  description: undefined,
  courseTypeCode: undefined,
  defaultContent: undefined,  /* special - not sent through the API */
});

class HomeworkType extends HomeworkTypeRecord { }

HomeworkType.create = (data = []) => {
  if (Array.isArray(data) || List.isList(data)) {
    return data.map(HomeworkType.create);
  }
  if (Map.isMap(data)) {
    throw new Error('Map data unsupported in HomeworkType.create');
  }
  // TODO: For Let's Talk default content hack for OMO-2403
  if (is.object(data) && data.name === LETS_TALK_TYPE_NAME) {
    data.defaultContent = LETS_TALK_DEFAULT_CONTENT;  // eslint-disable-line
  }
  return new HomeworkType(data);
};

export default HomeworkType;



// WEBPACK FOOTER //
// ./data/Homework/Types/model.js